import { Auth } from "aws-amplify";

export async function signOut() {
  try {
    await Auth.signOut({ global: true });
  } catch (error) {
    console.error("error signing out: ", error);
  }
}
